import { render, staticRenderFns } from "./add.vue?vue&type=template&id=38bb6f7b&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bb6f7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38bb6f7b')) {
      api.createRecord('38bb6f7b', component.options)
    } else {
      api.reload('38bb6f7b', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=38bb6f7b&scoped=true&", function () {
      api.rerender('38bb6f7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operate/cardOperationAnalysis/dialog/add.vue"
export default component.exports